import { Audit } from "./components/omnific/Audit";
import { Engage, Footer } from "./components/omnific/Engage";
import { Hero } from "./components/omnific/Hero";
import { Nav } from "./components/omnific/Nav";

export default function App() {
  return (
    <main id="top" className="relative min-h-screen bg-background">
      <div className="grid-overlay" />
      <div className="grain-overlay" />
      <Nav />
      <Hero />
      <Audit />
      <Engage />
      <Footer />
    </main>
  );
}
